/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Withdrawal_ConfirmInputs */

const en_withdrawal_confirm = /** @type {(inputs: Withdrawal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm withdrawal`)
};

const pl_withdrawal_confirm = /** @type {(inputs: Withdrawal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potwierdź odstąpienie`)
};

/**
* | output |
* | --- |
* | "Confirm withdrawal" |
*
* @param {Withdrawal_ConfirmInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const withdrawal_confirm = /** @type {((inputs?: Withdrawal_ConfirmInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Withdrawal_ConfirmInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_withdrawal_confirm(inputs)
	return en_withdrawal_confirm(inputs)
});